import type { MenuEntry } from '@/types/navigation'

export const buildB2bMenu = (): MenuEntry[] => []
